import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueI18n from 'vue-i18n';
import VeeValidate from 'vee-validate';
import customRules from '@/customRules/rules';
import i18n from '@/locale';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import App from './App.vue';

// import router from './router';
import store from './store';

Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);
Vue.use(VueI18n);
Vue.use(VeeValidate, {
  events: 'change|blur',
  customRules,
});
Vue.config.productionTip = false;

Vue.use(VueReCaptcha, {
  siteKey: '6LeCecQUAAAAAMSvEk2GbSl9EcopODuFhPY0hpRb',
  loaderOptions: { useRecaptchaNet: true, autoHideBadge: true },
});

new Vue({
  // router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app');
